import React from 'react'
import styled from 'styled-components'

import Text from 'components/Atoms/Text'
import { useTranslation } from 'i18n-web/i18next'

const Component = styled.div`
  background-color: #ffb840;
  padding: 16px;
  margin-bottom: 20px;
  .spacing {
    margin-top: 10px;
  }
`

const List = styled.ul`
  padding-left: 16px;
`

const Disclaimer = () => {
  const { t } = useTranslation()

  return (
    <Component>
      <Text className="semiBold" as="h4">
        {t('signUp.disclaimer.title')}
      </Text>
      <Text className="spacing">{t('signUp.disclaimer.description')}</Text>
      <Text className="spacing semiBold">
        {t('signUp.disclaimer.notSupportedDevices.title')}
      </Text>
      <List>
        <li>
          <Text className="spacing">
            {t('signUp.disclaimer.notSupportedDevices.devices.blackberry')}
          </Text>
        </li>
        <li>
          <Text>
            {t('signUp.disclaimer.notSupportedDevices.devices.windowsPhone')}
          </Text>
        </li>
        <li>
          <Text>
            {t('signUp.disclaimer.notSupportedDevices.devices.olderDevices')}
          </Text>
        </li>
      </List>
    </Component>
  )
}

export default Disclaimer
